import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectsReducerCreator } from '../types';

const setAddProjectsToGroupReducer = (create: ProjectsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<string[]>) => {
    state.addProjectsToGroup = action.payload;
  });
};

export default setAddProjectsToGroupReducer;
